import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core';

const FormControlLabel = ({ value, label, ...rest }) =>
    <MuiFormControlLabel
      value={value}
      label={label}
      {...rest}
    />

FormControlLabel.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
};

export default FormControlLabel;



// WEBPACK FOOTER //
// ./src/components/base/FormControlLabel/FormControlLabel.js